import React from "react";
import { inject, observer } from "mobx-react";
import _ from "lodash";
import Cache from "core/cache/index";
import Dropdown from "component/atoms/Dropdown";
import SVGIcons from "assets/icon";
import { addToolForElement } from "component/molecules/viewport/toolStates/addTool.js";
import { Crosshair3DTool } from "component/molecules/viewport/tools/annotation";
import { getEnabledElementById } from "component/toolManager/enabledElements";
import { setToolActiveForElement } from "component/molecules/viewport/toolStates/setToolMode.js";
import { getEnabledElements } from "component/toolManager/enabledElements.js";
import { getElementToolStateManager } from "component/toolManager/toolState";
import Config from "config";
/**
 * @description Contrast 버튼 클릭시 나타나는 확장 메뉴. UI Component Container
 * @function ContrastDropdownMenu
 */
@inject("toolbarStore")
@inject("gridLayoutStore")
@inject("seriesListStore")
@observer
class MPRDropdownMenu extends React.PureComponent {
  /**
   * @method getSelectedValue
   * @description Active된 뷰포트의 Contrast mode 반환. 자유변환시에는 "" 빈 문자열 리턴
   * @returns
   */
  getSelectedValue = () => {
    const { gridLayoutStore } = this.props;
    const selectedValue = gridLayoutStore.getMPROptionNameOnActiveDCMView();
    if (!!selectedValue === false) {
      return "";
    }

    if (typeof selectedValue !== "string") {
      return "";
    }

    return selectedValue;
  };
  isActive(value) {
    const selectedValue = this.getSelectedValue();

    if (selectedValue === value) {
      return true;
    }
    return false;
  }

  handle3DMPR = (eventKey, event) => {
    event.preventDefault();
    const { gridLayoutStore, toolbarStore, seriesListStore } = this.props;
    const pages = gridLayoutStore.getLayoutTotalPages();
    const metadataID = seriesListStore.getActiveSeriesItem();

    let metadataCache = new Cache.Metadata();
    const modality = metadataCache.getModality(metadataID);
    if (!!modality === false) {
      return;
    }

    if (["ct", "mr", "pt"].includes(modality.toLowerCase()) === false) {
      return;
    }
    let requestView = [];
    const isMPRActive = toolbarStore.getIsMPRActive();
    if (isMPRActive === false) {
      requestView.push({
        DCMViewIdx: 0,
        active: true,
        MetadataUID: metadataID,
        frameIdx: 0,
        BatchMode: false,
        imageOrientation: "axial",
        showTagOverlay: false,
        MPR: true,
        colorBox: "#00D400",
        onInitCallback: () => {
          const axialEnabledElement = getEnabledElementById(0);
          axialEnabledElement.image.mprColor = "#00D400";

          addToolForElement(axialEnabledElement.element, Crosshair3DTool, {
            configuration: { rotationAxis: "Y" },
          });
          //toolbarStore.activateMeasureTypeTool("crosshair3D");
          setToolActiveForElement(axialEnabledElement.element, "crosshair3D", {
            mouseButtonMask: 1,
            color: "#9ACD32",
            cosines: "1,0,0,0,1,0",
          });
          Config.rootStore.synchronizationStore.reactiveSyncState();
        },
      });
      requestView.push({
        DCMViewIdx: 1,
        active: true,
        MetadataUID: metadataID,
        frameIdx: 0,
        BatchMode: false,
        imageOrientation: "sagittal",
        showTagOverlay: false,
        MPR: true,
        colorBox: "#FF3D89",
        onInitCallback: () => {
          const coronalEnabledElement = getEnabledElementById(1);
          coronalEnabledElement.image.mprColor = "#FF3D89";
          addToolForElement(coronalEnabledElement.element, Crosshair3DTool, {
            configuration: { rotationAxis: "X" },
          });
          setToolActiveForElement(
            coronalEnabledElement.element,
            "crosshair3D",
            {
              mouseButtonMask: 1,
              color: "#0496FF",
              cosines: "1,0,0,0,0,-1",
            }
          );
          Config.rootStore.synchronizationStore.reactiveSyncState();
        },
      });
      requestView.push({
        DCMViewIdx: 2,
        active: true,
        MetadataUID: metadataID,
        frameIdx: 0,
        BatchMode: false,
        imageOrientation: "coronal",
        showTagOverlay: false,
        MPR: true,
        colorBox: "#FFE30D",
        onInitCallback: () => {
          const sagittalEnabledElement = getEnabledElementById(2);
          sagittalEnabledElement.image.mprColor = "#FFE30D";
          addToolForElement(sagittalEnabledElement.element, Crosshair3DTool, {
            configuration: { rotationAxis: "X" },
          });

          setToolActiveForElement(
            sagittalEnabledElement.element,
            "crosshair3D",
            {
              mouseButtonMask: 1,
              color: "#EFBDEB",
              cosines: "0,1,0,0,0,-1",
            }
          );
          Config.rootStore.synchronizationStore.reactiveSyncState();
        },
      });
      requestView.push({
        DCMViewIdx: 3,
        active: false,
        frameIdx: 0,
        BatchMode: false,
        showTagOverlay: false,
        MPR: true,
        onInitCallback: () => {},
      });

      gridLayoutStore.changeLayout(2, 2, pages);
      gridLayoutStore.setMetadataOnViewAsList(requestView);
      const axialEnabledElement = getEnabledElementById(0);
      const coronalEnabledElement = getEnabledElementById(1);
      const sagittalEnabledElement = getEnabledElementById(2);
      //toolbarStore.setIsMPRActive(!isMPRActive);
      toolbarStore.setIsMPRActive(true);

      if (!!_.get(axialEnabledElement, "element", null) === true) {
        axialEnabledElement.image = null;
        axialEnabledElement.needsRedraw = true;
      }

      //if (!!coronalEnabledElement.element === true) {
      if (!!_.get(coronalEnabledElement, "element", null) === true) {
        coronalEnabledElement.image = null;
      }

      if (!!_.get(sagittalEnabledElement, "element", null) === true) {
        sagittalEnabledElement.image = null;
      }
    } else {
      const { gridLayoutStore } = this.props;
      ///
      /// 데이터 삭제 메세지 전달
      ///
      gridLayoutStore.clearAll();
      let enabledElements = getEnabledElements();
      enabledElements.forEach(function (enabledElement) {
        const toolStateManager = getElementToolStateManager(
          enabledElement.element
        );
        toolStateManager.clearAll(enabledElement.element);
      });
      for (let i = 0; i < enabledElements.length; i++) {
        enabledElements[i].needsRedraw = true;
      }
      gridLayoutStore.changeLayout(1, 1, pages);
      toolbarStore.setIsMPRActive(false);
    }
  };
  clearAll() {}
  handleChangeView = (eventKey, event) => {
    event.preventDefault();
    const { gridLayoutStore } = this.props;

    if (eventKey === "1") {
      gridLayoutStore.setMPROptionNameOnActiveDCMView("coronal");
    } else if (eventKey === "2") {
      gridLayoutStore.setMPROptionNameOnActiveDCMView("sagittal");
    } else if (eventKey === "3") {
      gridLayoutStore.setMPROptionNameOnActiveDCMView("axial");
    }
  };

  render() {
    const { toolbarStore } = this.props;
    const isMPRActive = toolbarStore.getIsMPRActive();
    return (
      <React.Fragment>
        <Dropdown.Menu bsPrefix="dropdown-menu--toolbar">
          <Dropdown.Item
            bsPrefix="toolbar"
            className="dropdown-menu--toolbar__item__content"
            eventKey="1"
            activeIcon={SVGIcons.SVGDropdownCheckmarkIcon}
            onSelect={this.handle3DMPR}
            hotkey={"F2"}
            active={isMPRActive}
            as="div"
          >
            {`3D MPR`}
          </Dropdown.Item>
          {/* <Separator />
          <Dropdown.Item
            bsPrefix="toolbar"
            className="dropdown-menu--toolbar__item__content"
            eventKey="1"
            hotkey={"Ctrl+Alt+1"}
            activeIcon={SVGIcons.SVGDropdownCheckmarkIcon}
            onSelect={this.handleChangeView}
            active={this.isActive("coronal")}
            as="div"
          >
            {"Coronal"}
          </Dropdown.Item>
          <Dropdown.Item
            bsPrefix="toolbar"
            className="dropdown-menu--toolbar__item__content"
            eventKey="2"
            hotkey={"Ctrl+Alt+2"}
            activeIcon={SVGIcons.SVGDropdownCheckmarkIcon}
            onSelect={this.handleChangeView}
            active={this.isActive("sagittal")}
            as="div"
          >
            {"Sagittal"}
          </Dropdown.Item>
          <Dropdown.Item
            bsPrefix="toolbar"
            className="dropdown-menu--toolbar__item__content"
            eventKey="3"
            hotkey={"Ctrl+Alt+3"}
            activeIcon={SVGIcons.SVGDropdownCheckmarkIcon}
            onSelect={this.handleChangeView}
            active={this.isActive("axial")}
            as="div"
          >
            {"Axial"}
          </Dropdown.Item> */}
        </Dropdown.Menu>
      </React.Fragment>
    );
  }
}

export default MPRDropdownMenu;
